import { useEffect, useRef, useState } from 'react';
import { LoaderIcon, PromoCodeIcon } from '../../utils/svg';
import { axiosInstance } from '../../utils/helper';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import useKeyboard from '../../hook/useKeyboard';

const PromoSchema = Yup.object().shape({
	code: Yup.string().trim().required('Please enter a promo code'),
});

const PromoCode = ({ onSubmit = () => {}, cart = null, totalOrder = 0 }) => {
	const inputRef = useRef(null);
	const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((store) => store?.user);
	const isKeyboardVisible = useKeyboard();

	useEffect(() => {
		const timer = setTimeout(() => {
			if (inputRef.current) inputRef.current.blur();
		}, 100);
		return () => clearTimeout(timer);
	}, []);

	const formik = useFormik({
		initialValues: {
			code: '',
		},
		validationSchema: PromoSchema,
		validateOnBlur: false,
		validateOnMount: false,
		onSubmit: async (values) => {
			await handleReddem(values.code);
		},
	});

	const { values, setFieldValue, handleSubmit, errors, touched, setFieldError, setTouched } = formik;

	const handleReddem = async (code = null) => {
		console.log('handleReddem');
		try {
			setIsLoading(true);

			const postDataVg = {
				code: code,
				customer_id: user?.customerID,
				company_id: Number(user?.companyID),
				brand_id: Number(cart?.store?.outletBrandID),
				outlet_id: Number(cart?.store?.storeID),
				category_id: cart?.item?.map((c) => c?.product_category_id),
				product_id: cart?.item?.map((c) => c?.product_primary_id),
				total_order: totalOrder,
				birthday_date: user?.birthDate,
				total_transaction: Number(cart?.subTotal),
			};
			const vgUrl = 'voucher-global/apply-code';
			const resVg = await axiosInstance.post(vgUrl, postDataVg, {
				headers: {
					'Content-Type': 'application/json',
				},
				timeout: 10 * 1000,
			});

			if (resVg?.data?.status === 'ok') {
				onSubmit(resVg?.data?.data);
			  setFieldValue('code', '')
			  setFieldError('code', undefined);
			  setTouched({ ...touched, ['code']: false });
			}

			setIsLoading(false);
		} catch (error) {
      setFieldError('code', error?.response?.data?.message);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		const scrollElement = document.querySelector('[data-rsbs-scroll="true"]');
		const footerElement = document.querySelector('[data-rsbs-footer="true"]');
		if(!inputRef.current || !scrollElement || !isKeyboardVisible) return;

		const scroll = () => {
			scrollElement.scrollTo({
				top: inputRef.current.offsetHeight + footerElement.clientHeight,
				behavior: "smooth"
			});
		}

		scroll();
	}, [isKeyboardVisible]);

	return (
		<div className='border-b-1 border-solid border-gray-200 mb-4 p-4 relative'>
			<div className='flex'>
				<PromoCodeIcon className={'w-36 h-full'} />
				<div className='pl-4 flex flex-col justify-center'>
					<div className='max-w-[75%] font-medium text-lg text-gray-700'>Do you have a Promo or Referral code?</div>
					<div className='font-normal text-sm text-gray-400'>You can enter the code here</div>
				</div>
			</div>
			<div className='flex pt-5 gap-4 items-center relative'>
				{isLoading && (
					<div className='flex justify-center items-center w-full absolute z-10'>
						<LoaderIcon />
					</div>
				)}
				<div className='w-full relative'>
					<label htmlFor='promo_code' className={`absolute -top-[20%] left-5 bg-white px-1 text-[var(--rose-violet)] ${isLoading && 'bg-gray-100 text-gray-500'}`}>
						Enter Code
					</label>
					<input
						ref={inputRef}
						id='promo_code'
						name='code'
						value={values.code}
						onChange={(e) => {
							const { name, value } = e.target;
							if (value.trim() === '') {
								setFieldValue(name, '');
								setFieldError(name, undefined);
								setTouched({ ...touched, [name]: false });
								return;
							}
							setFieldValue(name, value);
						}}
						disabled={isLoading}
						placeholder='Enter code here'
						className='border border-solid border-gray-400 w-full px-2 py-4 rounded-lg disabled:bg-gray-100'
					/>
					{touched.code && errors.code && <p className='text-red-500 text-xs absolute'>{errors.code}</p>}
				</div>
				<button disabled={isLoading} onClick={handleSubmit} className={`w-36 h-10 rounded-full text-white border-[var(--rose-violet)] bg-[var(--rose-violet)] font-semibold text-sm disabled:bg-gray-300 disabled:border-gray-300`}>
					Claim
				</button>
			</div>
		</div>
	);
};

export default PromoCode;
